// logout
export const LOG_OUT = 'LOG_OUT';
export const LOG_OUT_DONE = 'LOG_OUT_DONE';
export const LOG_OUT_ERROR = 'LOG_OUT_ERROR';

export const SET_LOGIN_FETCHING = 'SET_LOGIN_FETCHING' as const;
export const HAS_SESSION_ALREADY = 'HAS_SESSION_ALREADY' as const;

export const SET_LOGIN_SESSION = 'SET_LOGIN_SESSION' as const;
export const REMOVE_LOGIN_SESSION = 'REMOVE_LOGIN_SESSION' as const;

export const SET_TPC_ENABLED = 'SET_TPC_ENABLED' as const;

export enum LOGIN_TYPE {
    /* User was not logged in before */
    NEW_LOGIN = 'NEW_LOGIN',
    /* User was logged in and confirmed his account */
    CONFIRM_ACCOUNT = 'CONFIRM_ACCOUNT',
    /* User was logged in as account A, but chose account B during Connect phase */
    RESELECT_ACCOUNT = 'RESELECT_ACCOUNT'
}

export const ANALYTICS_ATTRIBUTES = {
    location: 'page',
    category: 'login',
    action: {
        login: 'signed in',
        logout: 'logged out'
    }
};
